import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
import Titulo, { EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import { Axios } from "@/Services/Axios";
import { MutationBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Dayjs } from "dayjs";
export enum EnumFrequencia {
    Mensal = 1,
    Anul = 2
}

export type RepetirLancamentoType = {
    numeroRepeticao : number;
    diaRepeticao : number;
    codFrequencia : number;
    valorPrevisto : number;
};

export type ParcelamentoType = {
    numeroRepeticao : number;
    diaParcela : number;
    valorPrevisto : number;
};

export type LancamentoType = {
    codViagem?: number;
    codInscricao?: number;
    codCentroDeCustos?: number;
    codPlanoDeContas ?: number;
    repetirLancamento?: RepetirLancamentoType;
    parcelamento?: ParcelamentoType;
    titulo?: Titulo;
};

export function useLancamentoAPagar({
    onSuccess,
    ...rest
}:MutationBasicaParam<
    LancamentoType, 
    AxiosResponse<void>
>) {
    return useMutation({
        ...rest,
        mutationFn : (lancamento) => {
            if (lancamento.titulo?.movimentacao) lancamento.titulo.movimentacao.entrada = false;
            const isAlteracao = lancamento?.titulo?.codigo !== undefined && isFinite(lancamento?.titulo?.codigo) && !isNaN(lancamento?.titulo?.codigo) && (lancamento?.titulo?.codigo ?? 0) > 0;
            if (isAlteracao && (lancamento?.titulo?.codTipo ?? EnumTituloTipo.Parcela) === EnumTituloTipo.Titulo)
            {
                return Axios.put<void>(`financeiro/titulo/fatura/a-pagar/${lancamento?.titulo?.codigo}/lancamento`, lancamento);
            }
            return isAlteracao ? Axios.put<void>(`financeiro/titulo/parcela/a-pagar/${lancamento?.titulo?.codigo}/lancamento`, lancamento) : Axios.post<void>("financeiro/titulo/parcela/a-pagar/lancamento", lancamento);
        },
        onSuccess : (retorno, entrada, context) => {
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useLancamentoAReceber({
    onSuccess,
    ...rest
}:MutationBasicaParam<
    LancamentoType, 
    AxiosResponse<void>
>) {
    return useMutation({
        ...rest,
        mutationFn : (lancamento) => {
            if (lancamento.titulo?.movimentacao) lancamento.titulo.movimentacao.entrada = true;
            const isAlteracao = lancamento?.titulo?.codigo !== undefined && isFinite(lancamento?.titulo?.codigo) && !isNaN(lancamento?.titulo?.codigo) && (lancamento?.titulo?.codigo ?? 0) > 0;
            if (isAlteracao && (lancamento?.titulo?.codTipo ?? EnumTituloTipo.Parcela) === EnumTituloTipo.Titulo)
            {
                return Axios.put<void>(`financeiro/titulo/fatura/a-receber/${lancamento?.titulo?.codigo}/lancamento`, lancamento);
            }
            return isAlteracao ? Axios.put<void>(`financeiro/titulo/parcela/a-receber/${lancamento?.titulo?.codigo}/lancamento`, lancamento) : Axios.post<void>("financeiro/titulo/parcela/a-receber/lancamento", lancamento);
        },
        onSuccess : (retorno, entrada, context) => {
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export type LancamentoReembolsoType = {
    codFatura:number;
    valorTotal:number;
    gerarParcelasComBaseNaReceita:boolean;
    qtdParcelas?:number;
    diaDaParcela?:number;
    dataPrimeiroReembolso:Date|Dayjs;
    pagamentos:Pagamento[];
}

export function useLancamentoAReceberReembolsar({
    onSuccess,
    ...rest
}:MutationBasicaParam<
    LancamentoReembolsoType, 
    AxiosResponse<Titulo>
>) {
    return useMutation({
        ...rest,
        mutationFn : (lancamento) => {
            return Axios.post<Titulo>(`financeiro/titulo/parcela/a-receber/${lancamento.codFatura}/reembolsar`, lancamento);
        },
        onSuccess : (retorno, entrada, context) => {
            onSuccess?.(retorno, entrada, context);
        }
    });
}